import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { black } from '../../../../theme';

const InfoIcon = ({ width, height, fill }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 25.187 25.187">
    <path
      d="M13-20.719A10.97,10.97,0,0,1,23.969-9.75,10.966,10.966,0,0,1,13,1.219,10.966,10.966,0,0,1,2.031-9.75,10.968,10.968,0,0,1,13-20.719Zm0-1.625A12.6,12.6,0,0,0,.406-9.75,12.593,12.593,0,0,0,13,2.844,12.593,12.593,0,0,0,25.594-9.75,12.6,12.6,0,0,0,13-22.344ZM11.172-4.875a.609.609,0,0,0-.609.609v.406a.609.609,0,0,0,.609.609h3.656a.609.609,0,0,0,.609-.609v-.406a.609.609,0,0,0-.609-.609h-.609v-7.109a.609.609,0,0,0-.609-.609H11.172a.609.609,0,0,0-.609.609v.406a.609.609,0,0,0,.609.609h.609v6.094ZM13-17.062a1.625,1.625,0,0,0-1.625,1.625A1.625,1.625,0,0,0,13-13.812a1.625,1.625,0,0,0,1.625-1.625A1.625,1.625,0,0,0,13-17.062Z"
      transform="translate(-0.406 22.344)"
      fill={fill}
    />
  </svg>
);

InfoIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fill: PropTypes.string,
};

InfoIcon.defaultProps = {
  width: 25,
  height: 25,
  fill: black,
};

export default memo(InfoIcon);
